import { combineReducers } from 'redux';
import { vtexReducer, vtexMiddleware } from './vtex-integration';
import { woocommerceReducer, woocommerceMiddleware } from './woocommerce-integration';
import { pipedriveReducer, pipedriveMiddleware } from './pipedrive-integration';
import { lojaIntegradaReducer, lojaIntegradaMiddleware } from './loja-integrada-integration';
import { facebookMiddleware } from './facebook-integration';
import { integrationsListReducer } from './integrations-list/integrations-list.state';
import { oauthStrategyMiddleware } from './integration-strategies';
import { integrationsPropertiesMiddleware } from './integrations-properties.middleware';
import { integrationsPropertiesReducer } from './integrations-properties.state';
import { integrationsOnboardingModalReducer } from './integrations-onboarding-modal/integrations-onboarding-modal.state';
import { integrationsOnboardingModalMiddleware } from './integrations-onboarding-modal/integrations-onboarding-modal.middleware';

export const getShopifyState = state => ({
    ...state.integrations.shopify,
});

export const integrationsReducers = combineReducers({
    vtex: vtexReducer,
    woocommerce: woocommerceReducer,
    pipedrive: pipedriveReducer,
    lojaIntegrada: lojaIntegradaReducer,
    list: integrationsListReducer,
    integrationsProperties: integrationsPropertiesReducer,
    onboardingModal: integrationsOnboardingModalReducer,
});

export const integrationsMiddlewares = [
    vtexMiddleware,
    woocommerceMiddleware,
    facebookMiddleware,
    pipedriveMiddleware,
    lojaIntegradaMiddleware,
    oauthStrategyMiddleware,
    integrationsPropertiesMiddleware,
    integrationsOnboardingModalMiddleware,
];
